import { CANADIAN_COUNTRY_CODE, US_COUNTRY_CODE } from './constants';

export const formatBusinessCountryCode = (countryCode) => {
  switch (countryCode) {
    case 'USA':
    case 'EE. UU.':
      return US_COUNTRY_CODE;
    case 'CAN':
    case 'Canada':
      return CANADIAN_COUNTRY_CODE;
    default:
      return countryCode;
  }
};
export const formatBusinessCountryName = (countryCode) => {
  switch (countryCode) {
    case 'USA':
    case 'US':
    case 'EE. UU.':
      return 'United States';
    case 'CAN':
    case 'Canada':
      return 'Canada';
    default:
      return countryCode;
  }
};

export const validBusinessDetails = (businessDetails = {}) =>
  !!businessDetails.streetNumber &&
  !!businessDetails.locality &&
  !!businessDetails.region &&
  !!businessDetails.postalCode &&
  !!businessDetails.country;

export const validBusinessInfoDetails = (businessInfo = {}) =>
  !!businessInfo.address &&
  !!businessInfo.city &&
  !!businessInfo.state &&
  !!businessInfo.zip &&
  !!businessInfo.country;
